var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{on:{"click":function($event){return _vm.$emit('selectApp', _vm.app)}}},[_c('v-list-item-avatar',[(_vm.app.icon)?_c('v-img',{attrs:{"src":_vm.app.icon.url}}):_vm._e()],1),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(" "+_vm._s(_vm.app.name)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }